import { Link, Text } from '@hotjar/hotsauce';
import { getSalesLink } from '@hotjar/upsell';
import { Trans, useTranslation } from 'react-i18next';
import { ModalSubitleStyles as S } from './ModalSubtitle.styles';

const DISCOVER_MORE_LINK = (
  <Link
    kind="standalone"
    style={{ fontSize: 'inherit', lineHeight: 'inherit' }}
    href={getSalesLink('BillingPage')}
    isExternal
  >
    -
  </Link>
);

interface SubTitleProps {
  isQualifyingSalesLead: boolean;
}

export const SubTitle = ({ isQualifyingSalesLead }: SubTitleProps): JSX.Element => {
  const { t } = useTranslation('trials', { keyPrefix: 'post-trial' });

  return (
    <S.SubtitleWrapper>
      <Text textType="body1">{t('our-recommendations')}</Text>
      {isQualifyingSalesLead && (
        <S.FullCoverageBenenfits>
          <Trans
            i18nKey="trials:post-trial.contact-sales-label"
            components={[DISCOVER_MORE_LINK]}
          />
        </S.FullCoverageBenenfits>
      )}
    </S.SubtitleWrapper>
  );
};
